import * as THREE from "three";

import {
  Datas,
  rsoType,
  subType,
  SatDatasByType,
  Tle,
  SubTypeValue,
  RSOTypeValue
} from "../types";
import { CAMERA, ObjectColor, RADIUS } from "../constants";
import { LabelType } from "@graphic/components/feature/objects/Label";
import { CurveType } from "@graphic/components/feature/objects/Curve";

export function getColorByType(type: RSOTypeValue | SubTypeValue): THREE.Color {
  const color = new THREE.Color();
  const colorNumber = getColorNumberByType(type);
  color.set(colorNumber);

  return color;
}

export const getLabelColorByType = (type?: LabelType) => {
  switch (type) {
    case "primary":
      return "#FFA500";
    case "secondary":
      return "#9933CC";
    default:
      return "rgba(60,60,60, 0.8)";
  }
};

export const getCurveColorByType = (type?: CurveType) => {
  switch (type) {
    case "primary":
      return "#FFA500";
    case "secondary":
      return "#9933CC";
    default:
      return "#ffffff";
  }
};

export function convertToColorString(colorNumber: number): string {
  const colorString = colorNumber.toString(16).padStart(6, "0");

  return `#${colorString}`;
}

export const convertToColorNumber = (colorString: string) => {
  return parseInt(colorString.replace("#", ""), 16);
};

export function getColorNumberByType(
  type: RSOTypeValue | SubTypeValue
): number {
  switch (type) {
    case rsoType.PAYLOAD:
      return ObjectColor.PAYLOAD;
    case subType.STARLINK:
      return ObjectColor.STARLINK;
    case subType.ONEWEB:
      return ObjectColor.ONEWEB;
    case subType.OTHERS:
      return ObjectColor.OTHERS;
    case rsoType.ROCKET_BODY:
      return ObjectColor.ROCKET_BODY;
    case rsoType.DEBRIS:
      return ObjectColor.DEBRIS;
    case rsoType.ENEMY:
      return ObjectColor.ENEMY;
    default:
      return ObjectColor.UNKNOWN;
  }
}
